window.FoxTheme = window.FoxTheme || {};

/**
 * BreakpointWatcher
 *
 * Watches a media query and fires a callback when the viewport crosses
 * the breakpoint threshold. Useful for re-initializing sliders or other
 * components whose behavior changes based on the active breakpoint.
 *
 * Usage:
 *   this.breakpointWatcher = new FoxTheme.BreakpointWatcher({
 *     mediaQuery: '(min-width: 768px)',
 *     onChange: (matches) => this.reinitSlider(),
 *   });
 *
 *   // Cleanup
 *   this.breakpointWatcher.destroy();
 */
FoxTheme.BreakpointWatcher = class BreakpointWatcher {
  constructor({ mediaQuery = '(min-width: 768px)', onChange } = {}) {
    if (typeof onChange !== 'function') return;

    this.mediaQueryList = window.matchMedia(mediaQuery);
    this.handleChange = () => onChange(this.mediaQueryList.matches);

    if (this.mediaQueryList.addEventListener) {
      this.mediaQueryList.addEventListener('change', this.handleChange);
    } else if (this.mediaQueryList.addListener) {
      this.mediaQueryList.addListener(this.handleChange);
    }
  }

  destroy() {
    if (!this.mediaQueryList || !this.handleChange) return;

    if (this.mediaQueryList.removeEventListener) {
      this.mediaQueryList.removeEventListener('change', this.handleChange);
    } else if (this.mediaQueryList.removeListener) {
      this.mediaQueryList.removeListener(this.handleChange);
    }

    this.mediaQueryList = null;
    this.handleChange = null;
  }
};
